import { useCallback } from 'react';
import apiClient from 'src/api/axiosClient';
import {
  GetPermissionsApiParams,
  GetProfileApiParams,
  UpdatePasswordApiParams,
  UpdateUserApiParams,
  GetRolesApiParams,
} from '../types';

export function useGetPermissionsApi(): GetPermissionsApiParams {
  return useCallback(
    params => apiClient.get(`/users/permissions`, { params }),
    []
  );
}

export function useGetRolesApi(): GetRolesApiParams {
  return useCallback(() => apiClient.get(`/roles`), []);
}

export function useGetProfileApi(): GetProfileApiParams {
  return useCallback(
    params => apiClient.get(`/users/me`, { params }),
    []
  );
}

export function useUpdatePasswordApi(): UpdatePasswordApiParams {
  return useCallback(
    (userId, params) => apiClient.put(`/users/${userId}/password`, params),
    []
  );
}

export function useUpdateUserApi(): UpdateUserApiParams {
  return useCallback(
    (userId, params) => apiClient.put(`/users/${userId}`, params),
    []
  );
}
